var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSettings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Settings - Constituents Hover - 2")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.6410473%",
    y1: "50.3589527%",
    x2: "0.358952703%",
    y2: "50.3589527%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0039CB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.15.-Universe-Builder---Preview-and-Validate---04",
    transform: "translate(-165.000000, -313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings---Constituents-Hover---2",
    transform: "translate(165.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 3.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-build",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 14 0 14 14 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1891667,11.0775 L7.8925,5.78083333 C8.435,4.41583333 8.155,2.80583333 7.0525,1.6975 C5.71083333,0.355833333 3.6225,0.233333333 2.135,1.31833333 L4.375,3.56416667 L3.54666667,4.38666667 L1.3125,2.1525 C0.2275,3.63416667 0.35,5.72833333 1.69166667,7.06416667 C2.77666667,8.14916667 4.3575,8.435 5.71083333,7.9275 L11.025,13.2416667 C11.2525,13.4691667 11.62,13.4691667 11.8475,13.2416667 L13.1891667,11.9 C13.4225,11.6783333 13.4225,11.3108333 13.1891667,11.0775 Z M11.4391667,12.0108333 L5.92083333,6.4925 C5.565,6.755 5.16833333,6.9125 4.75416667,6.97083333 C3.96083333,7.0875 3.12666667,6.84833333 2.52,6.24166667 C1.96583333,5.69333333 1.70916667,4.95833333 1.75,4.235 L3.5525,6.0375 L6.02583333,3.56416667 L4.22333333,1.76166667 C4.94666667,1.72083333 5.67583333,1.9775 6.23,2.52583333 C6.86,3.15583333 7.09916667,4.025 6.95333333,4.83583333 C6.88333333,5.25 6.70833333,5.635 6.44,5.97916667 L11.9525,11.4916667 L11.4391667,12.0108333 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "url(#linearGradient-1)"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Settings.639c57d2.svg";
export { ForwardRef as ReactComponent };